module.exports = __webpack_public_path__ + "static/img/collage 3.3cf04d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collage 3.jpg
// module id = r/l4
// module chunks = 0